import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLinkFigmaAccount } from '@/hooks/useLinkFigmaAccount';
import { I18N_KEYS } from '@/language/keys';
import { useGlobalStore } from '@/state/global.state';

export interface UseFigmaAccountLinkPromptResult {
  /** User-initiated OAuth (no auto-open). */
  linkAccount: () => void;
  isLinking: boolean;
  /** Snackbar with a Link CTA — for race/error paths after an action already started. */
  promptLinkAccount: (messageKey: string) => void;
}

/** Shared OAuth + Link-CTA snackbar used by Edit morph and connect error handling. */
export function useFigmaAccountLinkPrompt(): UseFigmaAccountLinkPromptResult {
  const { t } = useTranslation();
  const updateSnackbarData = useGlobalStore((s) => s.updateSnackbarData);
  const { link, isLinking } = useLinkFigmaAccount();

  const linkAccount = useCallback(() => {
    void link();
  }, [link]);

  const promptLinkAccount = useCallback(
    (messageKey: string) => {
      updateSnackbarData({
        text: t(messageKey),
        severity: 'info',
        icon: null,
        isOpen: true,
        action: {
          text: t(I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PASTE_LINK_ACCOUNT_ACTION),
          onClick: () => void link(),
        },
      });
    },
    [updateSnackbarData, t, link],
  );

  return { linkAccount, isLinking, promptLinkAccount };
}
